import React from 'react';
import { Building2, Mail, MapPin, ArrowUpRight } from 'lucide-react';
import { BlurFade } from '../magicui/blur-fade';
import { ShimmerButton } from '../magicui/shimmer-button';
import { company } from '../../data/site';

export default function Contact() {
  const cards = [
    { icon: Mail, title: 'Email', body: <a href={`mailto:${company.email}`} className="link-underline break-all">{company.email}</a> },
    {
      icon: MapPin,
      title: 'Office',
      body: (
        <>
          {company.addressLines.map((l) => (
            <span key={l} className="block">{l}</span>
          ))}
          <a href={company.mapUrl} target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-white">
            <span className="link-underline">View on map</span> <ArrowUpRight className="size-3.5" aria-hidden="true" />
          </a>
        </>
      ),
    },
    { icon: Building2, title: 'Legal entity', body: <>{company.legalName}<span className="block">Registered in Ukraine</span></> },
  ];

  return (
    <section id="contact" className="bg-white py-24 lg:py-32">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-[2.25rem] bg-ink px-7 py-14 text-white sm:px-12 lg:px-16 lg:py-20">
          <div aria-hidden="true" className="absolute -left-20 top-0 size-96 rounded-full bg-fusion-violet/25 blur-3xl" />
          <div aria-hidden="true" className="absolute -right-10 bottom-0 size-96 rounded-full bg-fusion-teal/20 blur-3xl" />
          <div className="relative grid gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-center">
            <div>
              <BlurFade inView>
                <p className="eyebrow !text-white/60">Contact</p>
              </BlurFade>
              <BlurFade inView delay={0.1}>
                <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-[-0.035em] text-balance sm:text-5xl">
                  Let’s talk about what you need.
                </h2>
              </BlurFade>
              <BlurFade inView delay={0.2}>
                <p className="mt-5 max-w-md text-white/70">
                  Questions about our products, partnerships or press — write to us and a member of the team will
                  reply.
                </p>
              </BlurFade>
              <BlurFade inView delay={0.3}>
                <ShimmerButton as="a" href={`mailto:${company.email}`} background="#3355FF" shimmerColor="#ffffff" className="mt-8 inline-flex w-fit gap-2 text-sm font-semibold">
                  <Mail className="size-4" aria-hidden="true" /> Email the team
                </ShimmerButton>
              </BlurFade>
            </div>

            <div className="grid gap-3">
              {cards.map(({ icon: Icon, title, body }, i) => (
                <BlurFade key={title} inView delay={0.1 * i}>
                  <div className="flex gap-4 rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10 backdrop-blur">
                    <span className="inline-flex size-11 shrink-0 items-center justify-center rounded-xl bg-white/10">
                      <Icon className="size-5" aria-hidden="true" />
                    </span>
                    <div className="min-w-0 text-sm leading-relaxed text-white/75">
                      <p className="mb-1 font-mono text-[0.68rem] uppercase tracking-[0.16em] text-white/45">{title}</p>
                      {body}
                    </div>
                  </div>
                </BlurFade>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
